var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// Smooth auto scroll slider for each instance
// document.addEventListener('DOMContentLoaded', function () {
//   // Select all elements with a dynamic ID that matches 'smoothscroll-{section.id}'
//   document.querySelectorAll('[id^="smoothscroll"]').forEach(function (slider) {
//     new Splide(slider, {
//       type: 'loop',
//       drag: 'free',
//       focus: 'center',
//       direction: slider.getAttribute('data-direction'),
//       arrows: false,
//       autoWidth: true,
//       pagination: false,
//       perPage: 4,
//       autoScroll: {
//         speed: 0,
//       },
//     }).mount(window.splide.Extensions);
//   });
// });

$('.abz-mobile-tab-slider').slick({
  dots: true,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true
});


$('.abz_icon-container').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});








// For Buy It Button Text Changed. 

document.addEventListener("DOMContentLoaded", function () {
  // Select the button with the given class
  var buyItNowButton = document.querySelector(
    ".shopify-payment-button__button.shopify-payment-button__button--unbranded"
  );

  // Check if the button exists
  if (buyItNowButton) {
    // Change the button text
    buyItNowButton.textContent = "Start Your Journey"; // Replace with your desired text
  }
});

// For PDP Add Body Class

document.addEventListener('DOMContentLoaded', function () {
  // Check if we are on the product page using the Shopify template variable
  if (window.location.pathname.includes('/products/')) {
    document.body.classList.add('abz-product-page');
  }
});


// ---------------------



//  Add class langify to Background------

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header');

  if (!header) return;

  const observer = new MutationObserver(() => {
    const dropdown = document.querySelector('.ly-switcher-wrapper');
    if (dropdown) {
      dropdown.addEventListener('click', function () {
        header.classList.add('is-filled');
      });
      observer.disconnect(); // stop observing after it's found and attached
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});



// ------------------------

// ----- Remove Title From Link --------

document.querySelectorAll('.abz_multi-column .prose a').forEach(link => {
  link.removeAttribute('title');
});

// ---------------------------------------
$('.video-slick-slider').slick({
  dots: false,
  arrows:true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false,
   prevArrow: $('.prev-next-buttons .js-prev'),
  nextArrow: $('.prev-next-buttons .js-next')
});

// Pause all videos on slide change
$('.video-slick-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  $('.shopify-video').each(function(){
    this.pause();
    this.currentTime = 0;
  });
});

// Play video on active slide
$('.video-slick-slider').on('afterChange', function(event, slick, currentSlide){
  let $video = $('.slick-current .shopify-video');
  if ($video.length) {
    $video.get(0).play();
  }
});